import gql from 'graphql-tag';

export const UPDATE_PAGE_FILTER = gql`
  mutation updatePageFilter($filter: PageFilterInput!, $orderBy: [String], $pagination: PagePaginationInput) {
    updatePageFilter(filter: $filter, orderBy: $orderBy, pagination: $pagination) @client
  }
`;
